export default "__VITE_ASSET__Coghr6hZ__"